import React, { FC } from "react";
import { MessageContainer } from "@app/pippa/components/message";
import "./main.scss";

const Main: FC = () => {
  return (
    <main className="widget-main">
      <MessageContainer />
    </main>
  );
};

export default Main;
